import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import Delete from "../../../images/delete.svg";
import Logo from "../../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "../loader";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { Email } from "@mui/icons-material";

export function TradeDirectory({ match }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // console.log(window.location);
  // console.log(match.url);
  const getPosts = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const postData = await api.tradeDirectoryGet(payload);
      // console.log(postData);
      if (postData?.success) {
        setData(postData.trades);
        setnoOfPost(postData.count);
        setLimit(postData.limit);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const deletePost = async (id) => {
    try {
      setLoader(true);
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this item?"
      );
      if (isConfirmed) {
        const userData = await api.tradeDirectoryDelete(id);
        console.log("deleted");
        getPosts();
      }

      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getPosts();
  }, [page, resetPage]);

  const handleSearch = async () => {
    if (searchMail) {
      let payload = {
        email: searchMail,
      };
      const res = await api.tradeDirectorySearch(payload);
      // console.log(res);
      if (res?.success) {
        setData(res?.trades);
        setLimit(res?.trades?.length || 10);
        setnoOfPost(res?.trades?.length || 0);
      } else {
        alert("Invalid Email Address");
      }
    } else {
      alert("Please insert email for search");
    }
  };

  const handleReset = () => {
    setResetPage(!resetPage);
    setPage(1);
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid payHistoryPage">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-12 d-flex justify-content-end">
                <button className="themeBtn" onClick={handleShow}>
                  Add Trade
                </button>
              </div>
              <div className="col-12 d-flex justify-content-between pr-0 flex-wrap mt-2">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Trade Directory ({noOfPost})
                </h4>
                <div className="searchMadmin">
                  <div className="inputM">
                    <div className="iM">
                      <i className="fa-solid fa-magnifying-glass"></i>
                      <input
                        onChange={(e) => setSearchMail(e.target.value)}
                        type="text"
                        placeholder="Search by pair..."
                      />
                    </div>
                    <i
                      className="fa-solid fa-magnifying-glass sIcon"
                      onClick={handleSearch}
                    ></i>
                  </div>
                  <button className="reset" onClick={() => handleReset()}>
                    <i className="fa-solid fa-arrow-rotate-right"></i>
                    Reset
                  </button>
                </div>
              </div>
            </div>
            {/* table */}
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noOfPost={noOfPost}
              limit={limit}
              deletePost={deletePost}
            />
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {/* /.container-fluid */}
      <Modal show={show} size="lg" onHide={handleClose} centered className="">
        <Modal.Body>
          <div className="otpModalMain">
            <div className="closeIcon" onClick={handleClose}>
              <i className="fa-solid fa-xmark" />
            </div>
            <AddTrade getPosts={getPosts} setShow={setShow} />
          </div>
        </Modal.Body>
      </Modal>
      {loader && <Loader />}
    </>
  );
}

const Table = ({ data, page, setPage, noOfPost, limit, deletePost }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Pair
                  </th>
                  <th scope="col" className="">
                    Side
                  </th>
                  <th scope="col" className="">
                    Entry
                  </th>
                  <th scope="col" className="">
                    TP1
                  </th>
                  <th scope="col" className="">
                    TP2
                  </th>
                  <th scope="col" className="">
                    TP3
                  </th>
                  <th scope="col" className="">
                    SL
                  </th>
                  <th scope="col" className="">
                    Exit Price
                  </th>
                  <th scope="col" className="">
                    Created At
                  </th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.pair || "-"}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.side || "-"}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.entryPrice || "-"}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.tp1 || "-"}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.tp2 || "-"}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.tp3 || "-"}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark  db">
                        {item?.stopLoss || "-"}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark  db">
                        {item?.exitPrice || "-"}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {formatDate(item?.createdAt)}
                      </div>
                    </td>

                    <td>
                      <div className="mr-5 w-40">
                        {/* <a href="#" className="mr-3"><img src={edit} alt="edit" /></a> */}
                        <a
                          className="cursor-pointer"
                          onClick={() => deletePost(item?._id)}
                        >
                          <img src={Delete} alt="Delete" />
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfPost / limit)}
                page={page}
                onChange={handleChange}
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export function AddTrade({ getPosts, setShow }) {
  const adminStore = useSelector((state) => state.adminReducer);

  const [loader, setLoader] = useState(false);
  const [inputData, setInputData] = useState({});

  const validate = () => {
    if (!inputData?.pair) {
      return "Please add pair";
    }
    if (!inputData?.side) {
      return "Please select side";
    }
    if (!inputData?.entryPrice) {
      return "Please add entry price";
    }
    return false;
  };

  const handleSubmit = async () => {
    try {
      let validator = validate();
      if (validator) {
        alert(validator);
        return;
      }
      setLoader(true);
      let payload = {
        postedBy: adminStore.admin.admin._id,
        pair: inputData?.pair,
        side: inputData?.side,
        entryPrice: inputData?.entryPrice,
        tp1: inputData?.tp1 || null,
        tp2: inputData?.tp2 || null,
        tp3: inputData?.tp3 || null,
        stopLoss: inputData?.stopLoss || null,
        exitPrice: inputData?.exitPrice || null,
      };
      // console.log(payload);
      const response = await api.tradeDirectoryCreate(payload);
      if (response?.success) {
        alert("Trade added successfully.");
        setInputData({
          email: "",
          description: "",
        });
        setLoader(false);

        getPosts();
        setShow(false);
      } else {
        setLoader(false);
        alert("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error?.message);
      console.log(error);
      alert(error?.message || "Something went wrong");
    }
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-xl-6 col-md-7  d-flex justify-content-between pr-0">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Trade Directory
                </h4>
              </div>
            </div>
            <div className="card sortby-box br-10 border-transparent mt-3">
              <div className="card-header br-10  bg-white border-transparent py-3 ">
                <div className="form-group my-3">
                  <input
                    type="text"
                    name="pair"
                    value={inputData?.pair}
                    className="form-control"
                    placeholder="Enter Pair"
                    onChange={(e) =>
                      setInputData({ ...inputData, pair: e.target.value })
                    }
                  />
                </div>
                <div className="form-group my-3">
                  <select
                    className="form-control"
                    onChange={(e) =>
                      setInputData({ ...inputData, side: e.target.value })
                    }
                  >
                    <option value="">select Side</option>
                    <option value="long">Long</option>
                    <option value="short">Short</option>
                    <option value="spot">Spot</option>
                  </select>
                </div>
                <div className="form-group my-3">
                  <input
                    type="number"
                    name="entryPrice"
                    value={inputData?.entryPrice}
                    className="form-control"
                    placeholder="Entry Price"
                    onChange={(e) =>
                      setInputData({ ...inputData, entryPrice: e.target.value })
                    }
                  />
                </div>
                <div className="form-group my-3">
                  <input
                    type="number"
                    name="tp1"
                    value={inputData?.tp1}
                    className="form-control"
                    placeholder="Take Profit 1"
                    onChange={(e) =>
                      setInputData({ ...inputData, tp1: e.target.value })
                    }
                  />
                </div>
                <div className="form-group my-3">
                  <input
                    type="number"
                    name="tp2"
                    value={inputData?.tp2}
                    className="form-control"
                    placeholder="Take Profit 2"
                    onChange={(e) =>
                      setInputData({ ...inputData, tp2: e.target.value })
                    }
                  />
                </div>
                <div className="form-group my-3">
                  <input
                    type="number"
                    name="tp3"
                    value={inputData?.tp3}
                    className="form-control"
                    placeholder="Take Profit 3"
                    onChange={(e) =>
                      setInputData({ ...inputData, tp3: e.target.value })
                    }
                  />
                </div>
                <div className="form-group my-3">
                  <input
                    type="number"
                    name="stopLoss"
                    value={inputData?.stopLoss}
                    className="form-control"
                    placeholder="Stop Loss"
                    onChange={(e) =>
                      setInputData({ ...inputData, stopLoss: e.target.value })
                    }
                  />
                </div>
                <div className="form-group my-3">
                  <input
                    type="number"
                    name="exitPrice"
                    value={inputData?.exitPrice}
                    className="form-control"
                    placeholder="Exit Price"
                    onChange={(e) =>
                      setInputData({ ...inputData, exitPrice: e.target.value })
                    }
                  />
                </div>

                <div className="sendMailBtn mt-3">
                  <button onClick={handleSubmit} className="btn-dark">
                    Submit
                  </button>
                </div>
              </div>
            </div>
            {/* table */}
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && (
        <div className="seekoLoader">
          <div className="loader">
            <img src={Logo} alt="loader" />
          </div>
        </div>
      )}
    </>
  );
}
